import * as React from "react";
import { connect } from "react-redux";
import { IdMenuBalancing } from "../../constants/IdMenuBalancing";
import { selectActiveThemedEventInfo, selectThemedEvent, selectThemedEventMaxDifficultyLevel, selectThemedEventPlayerDifficultyLevelNumber, selectThemedEventTimeRemaining, } from "../../selectors/selectEventInfo";
import { DifficultyLevel } from "../generic/difficultyLevel/DifficultyLevel";
import { MenuWrapper } from "../menus/MenuWrapper";
import { actionModalClose } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { TimeRemaining } from "../time/TimeRemaining";
import { ThemedEventCateogry } from "./ThemedEventCategory";
var MenuThemedEventDOM = function (_a) {
    var onClose = _a.onClose, remainingTime = _a.remainingTime, difficultyLevel = _a.difficultyLevel, maxDifficultyLevel = _a.maxDifficultyLevel, themedEventInfo = _a.themedEventInfo, activeThemedEvent = _a.activeThemedEvent;
    if (!activeThemedEvent || themedEventInfo == undefined) {
        return React.createElement(React.Fragment, null);
    }
    var footerDOM = (React.createElement(React.Fragment, null,
        React.createElement(DifficultyLevel, { difficultyLevel: difficultyLevel, difficultyLevelMax: maxDifficultyLevel, className: "themed-event-menu-difficulty" }),
        React.createElement(TimeRemaining, { remainingTime: remainingTime })));
    var themedEventTab = [
        {
            icon: themedEventInfo.icon,
            id: ThemedEventCateogry.Event,
            locaKey: themedEventInfo.category.toString(),
            name: themedEventInfo.name,
        },
    ];
    return (React.createElement(MenuWrapper, { onClose: onClose, type: IdMenuBalancing.ThemedEvent, footerRenderer: footerDOM, customTabs: themedEventTab, modalId: IdModal.ThemedEvent }));
};
var mapState = function (state) { return ({
    activeThemedEvent: selectThemedEvent(state),
    difficultyLevel: selectThemedEventPlayerDifficultyLevelNumber(state),
    maxDifficultyLevel: selectThemedEventMaxDifficultyLevel(state),
    remainingTime: selectThemedEventTimeRemaining(state),
    themedEventInfo: selectActiveThemedEventInfo(state),
}); };
var mapDispatch = function (dispatch) { return ({
    onClose: function () { return dispatch(actionModalClose(IdModal.ThemedEvent)); },
}); };
export var MenuThemedEvent = connect(mapState, mapDispatch)(MenuThemedEventDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/themed-events/MenuThemedEvent.tsx
// module id = 2939
// module chunks = 3